export default {
  messageCenter: '消息中心',
  all: '全部',
  clientPriceQuery: '查看详情',
  unreadOnly: '只看未读',
  markAllAsRead: '全部标记已读',
  messageSetting: '消息设置',
  messageCategory: '消息分类',
  search: '搜索',
  query: '查询',
  selectTimeRange: '选择时间范围',
  startTime: '开始时间',
  endTime: '结束时间',
  messageList: '消息列表',
  noData: '暂无消息',
  unreadCount: '未读消息数',
  allMessages: '全部消息',
  messageTitle: '消息标题',
  messageContent: '消息内容',
  sendTime: '发送时间',
  sender: '发送人',
  markAsRead: '标记已读',
  delete: '删除',
  view: '查看',
  noMessages: '暂无消息',
  loading: '加载中...',
  subscriptionManagement: '订阅管理',
  selectCategories: '选择要订阅的消息分类',
  subscribe: '订阅',
  unsubscribe: '取消订阅',
  save: '保存',
  cancel: '取消',
  close: '关闭',
  confirm: '确认',
  success: '成功',
  error: '错误',
  total: '共',
  items: '条',
  page: '页',
  rows: '行',
  noMoreData: '没有更多数据了',
  searchPlaceholder: '输入关键词搜索消息',
  categoryMessages: '{count}条未读',
  pleasePick: '请选择时间范围',
  from: '至',
  noPermission: '您无权限访问此页面'
}
